import "./account-control.css";
import { SignOutIcon, UserPlusIcon } from "@phosphor-icons/react";
import { useState } from "react";
import { useAuth } from "./AuthProvider";
import { authErrorMessage } from "./errors";

export function AccountControl() {
  const { status, signOut: onSignOut, exitGuest } = useAuth();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");

  async function signOut(): Promise<void> {
    setPending(true);
    setError("");
    try {
      await onSignOut();
    } catch (cause) {
      setError(authErrorMessage(cause));
      setPending(false);
    }
  }

  if (status === "guest")
    return (
      <button className="button compact dark pm-rail-utility-button" onClick={exitGuest} type="button">
        <UserPlusIcon aria-hidden="true" size={20} />
        <span className="pm-rail-label">Create account</span>
      </button>
    );
  return (
    <>
      <button
        aria-label="Sign out"
        className="button compact dark pm-auth-sign-out pm-rail-utility-button"
        disabled={pending}
        onClick={() => void signOut()}
        type="button"
      >
        <SignOutIcon aria-hidden="true" size={20} />
        <span className="pm-rail-label">{pending ? "Signing out…" : "Sign out"}</span>
      </button>
      {error ? (
        <p className="pm-sign-out-error" role="alert">
          {error}
        </p>
      ) : null}
    </>
  );
}
